import { ModuloModel } from './ModuloModel'

export type UF =
  | 'AC'
  | 'AL'
  | 'AP'
  | 'AM'
  | 'BA'
  | 'CE'
  | 'DF'
  | 'ES'
  | 'GO'
  | 'MA'
  | 'MT'
  | 'MS'
  | 'MG'
  | 'PA'
  | 'PB'
  | 'PR'
  | 'PE'
  | 'PI'
  | 'RJ'
  | 'RN'
  | 'RS'
  | 'RO'
  | 'RR'
  | 'SC'
  | 'SP'
  | 'SE'
  | 'TO'

// Content section interfaces
export interface ContentSections {
  hero?: {
    heroImage?: string // URL of the hero image for course detail page
    title?: string
    subtitle?: string
  }
  aboutAccredited?: {
    title?: string
    html?: string
    badgeSrc?: string
    badgeAlt?: string
    showBadge?: boolean
  }
  aboutOverview?: {
    title?: string
    text?: string
    html?: string
  }
  aboutContent?: {
    metrics?: {
      modules?: number
      lessons?: number
      minDays?: number
      maxDays?: number
    }
    certificationText?: string
    validityText?: string
  }
  aboutDetails?: {
    subtitle?: string
    learningTopics?: Array<{
      title: string
      description: string
    }>
  }
  requirements?: {
    subtitle?: string
    note?: string
    modules?: Array<{
      id: string
      title: string
      hours?: string
      content?: string
    }>
  }
  aboutCertification?: {
    subtitle?: string
    targetAudience?: Array<{
      title: string
      description: string
    }>
  }
  benefits?: {
    opportunitiesText?: string
    opportunitiesList?: string[]
    prerequisitesText?: string
    prerequisites?: string[]
    instructionsText?: string
    instructions?: string[]
  }
  aboutAdditionalInfo?: {
    additionalInfoCards?: Array<{
      number?: string
      title: string
      description: string
    }>
  }
  governmentCertification?: {
    title?: string
    text?: string
    bullets?: string[]
    note?: string
  }
  expandableContent?: {
    title?: string
    html?: string
  }
  faq?: {
    title?: string
    faqTabs?: Record<
      string,
      {
        label: string
        items: Array<{
          id: string
          question: string
          answer: string
        }>
      }
    >
  }
}

export interface SiteMetadata {
  // Listing page fields
  originalPrice?: number
  finalPrice?: number
  featuredOrder?: number
  badges?: string[]
  customDescription?: string
  thumbnailImage?: string
  courseName?: string
  urlSlug?: string
  videoId?: string
  promoText?: string
  productTitle?: string
  sku?: string
  about?: string[]
  totalHistoricalEnrollment?: number
  datePublished?: string

  // Availability control
  isAllowed?: boolean
  pixDiscountPercentage?: number

  // Content sections for course detail pages
  sections?: ContentSections

  // UF-specific overrides
  uf?: { [K in UF]?: SiteMetadata }
}

export class CursoModel {
  id: number
  nome: string
  nomeReduzido: string
  diasParaEmissaoCertificado: number
  validadeCurso: number
  cargaHoraria: number
  categorias: string
  paginaLimiteGratuita?: number | null
  modulos?: ModuloModel[]
  siteMetadata?: SiteMetadata
}

export enum CURSOS {
  RECICLAGEM = 1,
  PREVENTIVO_RECICLAGEM = 18,
  COLETIVO_DE_PASSAGEIROS = 3,
  ESCOLAR = 4,
  PRODUTOS_PERIGOSOS = 5,
  EMERGENCIA = 6,
  CARGA_INDIVISIVEL = 7,
  ATUALIZACAO_COLETIVO_DE_PASSAGEIROS = 8,
  ATUALIZACAO_ESCOLAR = 9,
  ATUALIZACAO_PRODUTOS_PERIGOSOS = 10,
  ATUALIZACAO_EMERGENCIA = 11,
  ATUALIZACAO_CARGA_INDIVISIVEL = 12,
  MOTOTAXISTA = 13,
  MOTOFRETISTA = 14,
  ATUALIZACAO_MOTOTAXISTA = 16,
  ATUALIZACAO_MOTOFRETISTA = 17,
  DIRECAO_DEFENSIVA = 25,
  ATUALIZACAO_RENOVACAO_CNH = 23,
}
